export const TABLE_ENDPOINT = "api/Market/Players/table";
export const EXCEL_ENDPOINT = "api/Market/Players/excel";
export const TABLE_ENDPOINT_WEBSITES_ONLY = "api/Market/Players/OnlyWesbitesData/Table";
export const EXCEL_ENDPOINT_WEBSITES_ONLY = "api/Market/Players/OnlyWesbitesData/Excel";
export const ENTITIES_PER_PAGE = 100;
